// Vendor imports
const Immutable = require('immutable')
// Client V2 common imports
const { keyedReviver } = require('client-v2/common/state/record-reviver')

class HeaderImageModalRecord extends Immutable.Record({
  droppedFile: null,
  isVisible: Boolean(),
  savedImageUrl: String(),
  // TODO: Remove these callbacks once mix-edit-modal is converted to React/Redux
  onDelete: null,
  onDismiss: null,
  onSubmit: null
}) {
  static hide() {
    return new HeaderImageModalRecord({
      isVisible: false
    })
  }

  static show(payload) {
    return new HeaderImageModalRecord({
      ...payload,
      isVisible: true
    })
  }
}

HeaderImageModalRecord.reviver = keyedReviver(HeaderImageModalRecord, {
  // No nested data structures
})

module.exports = HeaderImageModalRecord
